import { render, staticRenderFns } from "./aRmsDayPickupTooltip.vue?vue&type=template&id=38df5eb9"
import script from "./aRmsDayPickupTooltip.vue?vue&type=script&lang=js"
export * from "./aRmsDayPickupTooltip.vue?vue&type=script&lang=js"
import style0 from "./aRmsDayPickupTooltip.vue?vue&type=style&index=0&id=38df5eb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VIcon,VTooltip})
